var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57596 16.1232C8.36886 16.4819 8.49176 16.9406 8.85048 17.1477C9.2092 17.3548 9.66789 17.2319 9.875 16.8732L15.489 7.14954C15.6961 6.79082 15.5732 6.33213 15.2144 6.12502C14.8557 5.91791 14.397 6.04082 14.1899 6.39954L8.57596 16.1232ZM8 10C8.55228 10 9 9.5523 9 9.00002C9 8.44773 8.55228 8.00002 8 8.00002C7.44772 8.00002 7 8.44773 7 9.00002C7 9.5523 7.44772 10 8 10ZM8 11.5C9.38071 11.5 10.5 10.3807 10.5 9.00002C10.5 7.61931 9.38071 6.50002 8 6.50002C6.61929 6.50002 5.5 7.61931 5.5 9.00002C5.5 10.3807 6.61929 11.5 8 11.5ZM16 15C16.5523 15 17 14.5523 17 14C17 13.4477 16.5523 13 16 13C15.4477 13 15 13.4477 15 14C15 14.5523 15.4477 15 16 15ZM16 16.5C17.3807 16.5 18.5 15.3807 18.5 14C18.5 12.6193 17.3807 11.5 16 11.5C14.6193 11.5 13.5 12.6193 13.5 14C13.5 15.3807 14.6193 16.5 16 16.5Z",
    fill: "#B6B8D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPercent);
export default __webpack_public_path__ + "static/media/icn-percent.81d6f6ef031d9d3855a9f68b8fc67627.svg";
export { ForwardRef as ReactComponent };